import { ChartBaseTooltip } from '../common/ChartBaseTooltip';

export class SwotTooltip extends ChartBaseTooltip {
    constructor ({ type, chartInteractions, chartDataHelper }) {
        super();
        chartInteractions.onModuleOverSeries(type, this.onDisplayPopup.bind(this));
        chartInteractions.onModuleOutSeries(type, this.onHidePopup.bind(this));
        this.chartData = chartDataHelper;
    }

    onDisplayPopup ({ seriesId, data, event }) {
        const content = `
            <span style="width: 10px; height: 10px; background-color: ${this.chartData.getSeriesColour(seriesId)}; border-radius: 50%; display: inline-block;"></span>
            ${this.chartData.getSeriesName(seriesId)}
            <hr>
            <table style="width:100%">
            <tr><td>Conversation:</td><td><b>${data[0].toFixed(2)}</b></td><tr>
            <tr><td>Quality:</td><td><b>${data[1].toFixed(2)}</b></td><tr>
            <tr><td>Community:</td><td><b>${data[2].toFixed(2)}</b></td><tr>
            </table>
        `;
        this.displayTooltip(content, event);
    }

    onHidePopup () {
        this.hideTooltip();
    }
}
